import {NgModule} from "@angular/core";
import {ÅrshjulOppsettKomponentAvhengigheter} from "web-ng2/moduler/årshjul/komponenter/årshjul-oppsett/årshjul-oppsett";
import {ÅrshjulInnslagRedigerListeKomponentAvhengigheter} from "web-ng2/moduler/årshjul/komponenter/årshjul-innslag-rediger-liste/årshjul-innslag-rediger-liste";

@NgModule({
    providers: [
        ÅrshjulOppsettKomponentAvhengigheter,
        ÅrshjulInnslagRedigerListeKomponentAvhengigheter,
    ]
})
export class ÅrshjulModul {
}
